import React from 'react';
import '../styles/Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <p>
        All Copyright &copy; By Flyingking Saddlery. &nbsp;&nbsp;&nbsp; Technical
        support by deepblue.
      </p>
    </footer>
  );
};

export default Footer;
